<div class="sidebar included">
	<app-sidebar-header [title]="'ancillaries.group.CHANGES' | ibeadmin: 'sync'"></app-sidebar-header>

	<div class="sidebar__body sl--scrollable" #sidebar__body>

		<app-flight-route [flight]="flight" *ngIf="flight"></app-flight-route>

		<app-included-per-passenger [flight]="flight" [brand]="brand" [feature]="feature" [passengers]="passengerList" *ngIf="flight">
		</app-included-per-passenger>

		<div class="sidebar-flight-text border">
			<h2 class="title-h2">
				{{ 'whatsIncludedSidebars.detailsChanges.titles.changesCancellationRules' | ibeadmin: 'sync' }}
			</h2>
			<div class="grid">
				<div class="col-12">
					<ul>
						<li>
							{{ 'whatsIncludedSidebars.detailsChanges.texts.changesCancellationRules1' | ibeadmin: 'sync' }}
						</li>
						<li>
							{{ 'whatsIncludedSidebars.detailsChanges.texts.changesCancellationRules2' | ibeadmin: 'sync' }}
						</li>
						<li>
							{{ 'whatsIncludedSidebars.detailsChanges.texts.changesCancellationRules3' | ibeadmin: 'sync' }}
						</li>
						<li>
							{{ 'whatsIncludedSidebars.detailsChanges.texts.changesCancellationRules4' | ibeadmin: 'sync' }}
						</li>
						<!--
						<li>
							{{ 'whatsIncludedSidebars.detailsChanges.texts.changesCancellationRules5' | ibeadmin: 'sync' }}
						</li>
						-->
					</ul>
				</div>
			</div>
		</div>

		<app-compare-brands [brand]="brand" [feature]="feature" *ngIf="!reviewFlights && !timeToThinkFlights"></app-compare-brands> 
		<div class="extras__helper with-notification">
			<div class="">
				<a class="link extras-feature__link" 
					aria-label="Close dialog"
					(click)="INDRA_handleClose()" 
					href="javascript:;" 
					role="button">
					{{ 'whatsIncludedSidebars.general.text.closeWindow' | ibeadmin: 'sync' }}
				</a>
			</div>
		</div>
	</div>
	<div #sidebar__footer class="sidebar__footer "></div>
</div>
